import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * `<labs-avatar-block>` displays an an avatar and text
 */
@Component({
  selector: 'labs-avatar-block',
  templateUrl: './avatar-block.component.html',
  styleUrls: ['./avatar-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvatarBlockComponent {}
